//NOTE: This library will eventually be extracted to Embercom Core https://github.com/intercom/embercom-core
import { get } from '@ember/object';
import platform from '@intercom/embercom-composer/lib/platform';
import Em from 'ember';
const ERROR_MESSAGE = 'An error occurred when uploading your file. Please try again.';
const extractFileName = function (fileOrBlob) {
  let fileName = fileOrBlob.name || '';
  //eslint-disable-next-line no-control-regex
  let hasNonAscii = fileName.match(/[^\x00-\x7F]/);
  if (!fileName || platform.get('isSafari') && hasNonAscii) {
    fileName = `File${new Date().getTime()}`;
  }
  return fileName;
};
const FileUpload = function (fileOrBlob, policyUrl, onProgress, attributes, ajaxService) {
  this.fileOrBlob = fileOrBlob;
  this.onProgress = onProgress;
  this.ajaxService = ajaxService;
  this.attributes = {
    content_type: this.fileOrBlob.type,
    size_in_bytes: this.fileOrBlob.size,
    original_filename: extractFileName(fileOrBlob)
  };
  for (let attribute in attributes) {
    //eslint-disable-next-line no-prototype-builtins
    if (attributes.hasOwnProperty(attribute)) {
      this.attributes[attribute] = attributes[attribute];
    }
  }
  this.policyUrl = policyUrl;
  this._state = 'initialized';
};
FileUpload.prototype = {
  upload() {
    this._reset();
    let promise = new Em.RSVP.Promise(function (resolve, reject) {
      this._resolve = resolve;
      this._reject = reject;
    }.bind(this));
    this._upload();
    return promise;
  },
  _upload() {
    this._getPolicyFile().then(success => {
      this._gotPolicyFile(success);
      this._uploadFile();
    }).catch(error => {
      let message = get(error, 'responseJSON.errors') || ERROR_MESSAGE;
      this._gotPolicyFileError(message);
    });
  },
  _getPolicyFile() {
    this._state = 'gettingPolicyFile';
    let policyUrl = this.policyUrl;
    let attributes = this.attributes;
    return this.ajaxService.ajax(policyUrl, 'POST', {
      upload: attributes
    });
  },
  _gotPolicyFileError(message) {
    this._state = 'failedGettingPolicyFile';
    this._reject({
      message,
      overSizeLimit: false
    });
  },
  _gotPolicyFile(data) {
    this._state = 'gotPolicyFile';
    this._policy = data;
  },
  _createFormData() {
    let policy = this._policy;
    let fileOrBlob = this.fileOrBlob;
    let fd = new FormData();
    fd.append('key', policy.key);
    fd.append('acl', policy.acl);
    fd.append('Content-Type', policy.content_type);
    fd.append('AWSAccessKeyId', policy.aws_access_key);
    fd.append('policy', policy.policy);
    fd.append('signature', policy.signature);
    fd.append('success_action_status', policy.success_action_status);
    fd.append('file', fileOrBlob, this.attributes.original_filename);
    return fd;
  },
  _uploadFile() {
    this._state = 'uploadingToS3';
    let policy = this._policy;
    let formData = this._createFormData();
    let xhr = new XMLHttpRequest();
    xhr.addEventListener('load', this._uploadComplete.bind(this), false);
    xhr.addEventListener('error', this._uploadFailed.bind(this), false);
    xhr.addEventListener('abort', this._uploadCancelled.bind(this), false);
    xhr.upload.addEventListener('progress', this._uploadProgress.bind(this), false);
    xhr.open('POST', policy.upload_destination, true); //MUST BE LAST LINE BEFORE YOU SEND
    xhr.send(formData);
    this.xhr = xhr;
  },
  _uploadProgress(e) {
    if (e.lengthComputable) {
      let percentComplete = Math.round(e.loaded * 100 / e.total);
      this.onProgress(percentComplete);
    } else {
      console.log('progress unable to compute');
    }
  },
  _uploadComplete() {
    if (this.xhr.status === 200 || this.xhr.status === 201) {
      this._state = 'doneUploadingToS3';
      this._confirmUploadSuccess();
    } else {
      this._uploadFailed();
    }
  },
  _confirmUploadSuccess() {
    this._state = 'confirmingUploadSuccess';
    this.ajaxService.ajax(this._policy.upload_url, 'PUT', {}).then(success => {
      this._state = 'success';
      this._resolve(this._policy);
    }).catch(error => {
      this._state = 'failedConfirmingSuccess';
      this._reject({
        message: 'There was a problem uploading your file',
        overSizeLimit: false
      });
    });
  },
  _uploadFailed() {
    let message = ERROR_MESSAGE;
    let overSize = false;
    if (this.xhr.responseText.match('EntityTooLarge')) {
      overSize = true;
      message = 'File too big';
      let maxSize = this.xhr.responseText.match(/<MaxSizeAllowed>([0-9]+)<\/MaxSizeAllowed>/);
      if (maxSize) {
        message += `. Max size is ${Math.floor(maxSize[1] / 1000000)}MB`;
      }
    }
    this._reject({
      message,
      overSizeLimit: overSize
    });
  },
  _uploadCancelled() {
    this._reject({
      message: 'Your upload was cancelled. Please try again.',
      overSizeLimit: false
    });
  },
  _reset() {
    if (this._state !== 'initialized') {
      this._state = 'initialized';
      this._reject();
    }
  }
};
export default FileUpload;